import { createStore } from '@stencil/store';

import { defaultInProgressVehicleState, baseVehicleState } from '../utils/utils.vehicle';

// Vehicle Details
const offerVehicleInitialState = {
  ...baseVehicleState,
  yearMakeModel: '',
  hasTwoSetsOfKeys: true,
  offerOptions: [],
  vehicleType: 'sedan',
  bodyStyle: '',
  accidentQuestionModifiedByDealer: false,
  hasThirdRow: false,
  imageUrl: '',
  chosenCondition: '',
  history: [], // TODO: needed?
  fullName: '',
  hasSingleOwner: false, // autocheck
  hasAccidents: false, // autocheck
  isAuctionedLast45: false, // prospect
  hasReplacement: false, // prospect
  isRental: false, // prospect
  replacementName: '',
  replacementMakeId: '',
  replacementModelId: '',
  replacementMake: '',
  replacementModel: '',
  replacementTypes: '',
  replacementVehicleYearMax: 2023,
  replacementVehicleYearMin: 2018,
  inProgressVehicle: { ...defaultInProgressVehicleState },
};

const { on, onChange, state, reset } = createStore(offerVehicleInitialState);

export { offerVehicleInitialState, on, onChange, state, reset };
export default state;
